import React from 'react';
import PropTypes from 'prop-types';
import EuroSymbol from '@mui/icons-material/EuroSymbol';
import OfferAdditionalDataComponent from '../components/OfferAdditionalDataComponent';
import FacilityOfferAdditionalDataComponent from '../components/FacilityOfferAdditionalDataComponent';
import { get } from '@totalsoft/change-tracking-react';
import { CollapseCard, FakeText } from '@totalsoft/rocket-ui';
import { useTranslation } from 'react-i18next';

export const OfferAdditionalDataCard = ({
  onPropertyChange,
  invoicingExchangeRates,
  acquisitionExchangeRates,
  creditFinancingLines,
  scheduleTypes,
  interestTypes,
  offerTypes,
  bankList,
  offerClientFacilities,
  loadClientFacilities,
  validation,
  onSave,
  onExpand,
  cardExpanded,
  saving,
  isDirty,
  offerFinancialProductRuleReadOnlyFields,
  variableInterestComputing,
  handleFacilityStateChange,
  isFacilityFrame,
  openLinkedDocument,
  onInterestVariablePercentRefresh,
  lens,
  additionalDataLoaded,
  offerHeaderLoading
}) => {
  const { t } = useTranslation();

  return (
    <CollapseCard
      id={'offerAdditionalDataCard'}
      icon={EuroSymbol}
      title={t('OfferEdit.AdditionalData.Title')}
      expanded={cardExpanded}
      onToggle={onExpand}
      toggleOnHeaderClick
    >
      {!additionalDataLoaded || offerHeaderLoading ? (
        <FakeText lines={5} />
      ) : (
        (lens.additionalData |> get) &&
        (!isFacilityFrame ? (
          <OfferAdditionalDataComponent
            onPropertyChange={onPropertyChange}
            invoicingExchangeRates={invoicingExchangeRates}
            acquisitionExchangeRates={acquisitionExchangeRates}
            creditFinancingLines={creditFinancingLines}
            scheduleTypes={scheduleTypes}
            interestTypes={interestTypes}
            offerTypes={offerTypes}
            bankList={bankList}
            offerClientFacilities={offerClientFacilities}
            loadClientFacilities={loadClientFacilities}
            onSave={onSave}
            saving={saving}
            isDirty={isDirty}
            offerFinancialProductRuleReadOnlyFields={offerFinancialProductRuleReadOnlyFields}
            validation={validation}
            variableInterestComputing={variableInterestComputing}
            onInterestVariablePercentRefresh={onInterestVariablePercentRefresh}
            lens={lens}
          />
        ) : (
          <FacilityOfferAdditionalDataComponent
            onPropertyChange={onPropertyChange}
            bankList={bankList}
            onSave={onSave}
            saving={saving}
            isDirty={isDirty}
            handleFacilityStateChange={handleFacilityStateChange}
            validation={validation}
            openLinkedDocument={openLinkedDocument}
            lens={lens}
          />
        ))
      )}
    </CollapseCard>
  );
};

OfferAdditionalDataCard.propTypes = {
  onPropertyChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onExpand: PropTypes.func.isRequired,
  cardExpanded: PropTypes.bool,
  saving: PropTypes.bool.isRequired,
  invoicingExchangeRates: PropTypes.array.isRequired,
  acquisitionExchangeRates: PropTypes.array.isRequired,
  creditFinancingLines: PropTypes.array.isRequired,
  scheduleTypes: PropTypes.array.isRequired,
  interestTypes: PropTypes.array.isRequired,
  offerTypes: PropTypes.array.isRequired,
  bankList: PropTypes.array.isRequired,
  offerClientFacilities: PropTypes.object.isRequired,
  loadClientFacilities: PropTypes.func.isRequired,
  isDirty: PropTypes.bool.isRequired,
  validation: PropTypes.object,
  offerFinancialProductRuleReadOnlyFields: PropTypes.object.isRequired,
  variableInterestComputing: PropTypes.bool.isRequired,
  handleFacilityStateChange: PropTypes.func,
  isFacilityFrame: PropTypes.bool.isRequired,
  openLinkedDocument: PropTypes.func,
  onInterestVariablePercentRefresh: PropTypes.func.isRequired,
  lens: PropTypes.object.isRequired,
  additionalDataLoaded: PropTypes.bool.isRequired,
  offerHeaderLoading: PropTypes.bool.isRequired
};

export default OfferAdditionalDataCard;
